<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="titulo-modal"
            >{{ isEditar ? "Editar" : "Adicionar" }} usuário</span
          >
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form v-model="valid">
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    class="input-font-size"
                    label="Login"
                    v-model="usuario.login"
                    hint="exemplo.dsn.erp"
                    :rules="[(v) => !!v || 'Login é obrigatório']"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="8">
                  <v-text-field
                    class="input-font-size"
                    label="Email"
                    v-model="usuario.email"
                    hint="usuario@alterdata.com.br"
                    :rules="[
                      (v) => !!v || 'E-mail é obrigatório',
                      (v) =>
                        /.+@alterdata.com.br/.test(v) ||
                        'E-mail deve ser válido',
                    ]"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-select
                    class="input-font-size"
                    :items="nomesPerfis"
                    label="Perfil"
                    v-model="usuario.perfil.descricao"
                    :rules="[(v) => !!v || 'Perfil é obrigatório']"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="8">
                  <v-select
                    :items="nomesSetores"
                    label="Setores"
                    v-model="usuario.setores"
                    :rules="[(v) => v.length !== 0 || 'Setor é obrigatório']"
                    required
                    multiple
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip
                        outlined
                        small
                        v-if="index === 0"
                        color="primary"
                        dark
                      >
                        <span class="input-font-size">{{ item }}</span>
                      </v-chip>
                      <v-chip
                        v-if="index === 1"
                        outlined
                        small
                        color="primary"
                        dark
                      >
                        <span class="input-font-size">{{ item }}</span>
                      </v-chip>
                      <v-chip
                        v-if="index === 2"
                        outlined
                        small
                        color="primary"
                        dark
                      >
                        <span class="input-font-size">{{ item }}</span>
                      </v-chip>
                      <span v-if="index === 3" class="grey--text text-caption">
                        (+{{ usuario.setores.length - 3 }}
                        {{
                          usuario.setores.length - 3 === 1 ? "outro" : "outros"
                        }}
                        )
                      </span>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            class="btn-primary ml-0 mb-3"
            @click="handleSalvar"
            text
            :disabled="!valid"
          >
            <v-progress-circular
              indeterminate
              v-if="carregando"
              color="white"
              :size="25"
              :width="3"
            ></v-progress-circular>
            <div v-else>Salvar</div>
          </v-btn>
          <v-btn
            class="btn-quaternary ml-0 mb-3"
            text
            @click="$emit('fecharModal')"
            >Cancelar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Usuario from "@/model/usuario/Usuario";
import usuarioApi from "@/api/usuario/usuario-api";
import { reject } from "q";
export default {
  props: ["setores", "perfis", "usuarioSelecionado"],
  data: () => ({
    isEditar: false,
    carregando: false,
    dialog: true,
    usuario: new Usuario(),
    nomesSetores: [],
    nomesPerfis: [],
    valid: false,
  }),
  methods: {
    montarArraySetores() {
      this.nomesSetores = this.setores.map((s) => s.nome);
    },
    montarArrayPerfis() {
      this.nomesPerfis = this.perfis.map((p) => p.descricao);
    },
    async handleSalvar() {
      this.carregando = true;
      if (this.isEditar) {
        try {
          await this.editarUsuario();
        } catch (error) {
          this.$emit(
            "erroEditarUsuario",
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
              "Não foi possível se comunicar com o servidor!"
          );
        }
      } else {
        try {
          await this.adicionarUsuario();
        } catch (error) {
          this.$emit(
            "erroAdicionarUsuario",
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
              "Não foi possível se comunicar com o servidor!"
          );
        }
      }
      this.carregando = false;
    },

    async editarUsuario() {
      this.obterIdPerfilSelecionado();
      this.obterIdSetoresSelecionados();

      await usuarioApi
        .atualizar(this.usuario.id, this.usuario)
        .then((response) => {
          this.$emit("editarUsuario", new Usuario(response.data));
        })
        .catch((error) => reject(error));
    },

    async adicionarUsuario() {
      this.obterIdPerfilSelecionado();
      this.obterIdSetoresSelecionados();

      await usuarioApi
        .cadastrar(new Usuario(this.usuario))
        .then((response) => {
          this.$emit("adicionarUsuario", new Usuario(response.data));
        })
        .catch((error) => reject(error));
    },

    obterIdPerfilSelecionado() {
      const perfil = this.perfis.filter(
        (p) => p.descricao === this.usuario.perfil.descricao
      );
      this.usuario.idPerfil = perfil[0].id;
    },

    obterIdSetoresSelecionados() {
      const setores = this.setores.filter((s) =>
        this.usuario.setores.includes(s.nome)
      );
      this.usuario.idSetores = setores.map((s) => s.id);
    },

    verificarSeVaiEditarOuAdicionar() {
      if (!this.usuarioSelecionado.id) {
        this.isEditar = false;
        this.usuario.perfil = [];
      } else {
        this.usuario = new Usuario(this.usuarioSelecionado);
        this.isEditar = true;
      }
    },
  },

  mounted() {
    this.verificarSeVaiEditarOuAdicionar();
    this.montarArraySetores();
    this.montarArrayPerfis();
  },
};
</script>

<style lang="scss" scoped>
.input-font-size {
  font-size: 16px;
}
</style>